class Label {
  constructor(label = {}) {
    this.id = label.id || '';
    this.extId = label.extId || '';

    this.name = label.name || '';
    this.color = label.color || '';
    this.languages = label.languages || {};
  }

  getCreateLabelDto() {
    const serverModel = { name: '' };
    if (this.name) serverModel.name = this.name;
    if (this.color) serverModel.color = this.color;
    Object.keys(serverModel).forEach((key) => {
      if (serverModel[key] === null) {
        delete serverModel[key];
      }
    });
    return serverModel;
  }

  getLabel(serverModel) {
    this.id = serverModel.id || '';
    this.extId = serverModel.extId || '';

    this.name = serverModel.name || '';
    this.color = serverModel.color || '';
    this.languages = serverModel.languages || {};

    return this;
  }
}

export default Label;
